var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWelltoryLogo = function SvgWelltoryLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.508 25.781c-1.785 0-2.967-.344-4.064-.774V22.47c1.312.58 2.838.838 4.107.838 2.472 0 3.289-1.268 3.289-3.289v-.967c-.709 1.075-1.763 1.784-3.332 1.784-3.075 0-4.322-1.806-4.322-5.353V9.053h2.946v6.536c0 1.913.602 2.924 2.128 2.924 1.527 0 2.58-1.29 2.58-2.924V9.054h2.946v11.051c0 3.59-2.279 5.676-6.278 5.676ZM101.998 20.75V9.054h2.945v1.87c.753-1.268 1.957-2.171 3.612-2.171v2.945a2.717 2.717 0 0 0-.602-.064c-1.806 0-2.988 1.505-3.01 3.741v5.375h-2.945ZM88.651 15.633v-1.419c0-3.677 2.408-5.461 5.526-5.461 3.117 0 5.568 1.784 5.568 5.461v1.419c0 3.655-2.45 5.44-5.568 5.44-3.118 0-5.526-1.785-5.526-5.44Zm3.01-1.44v1.44c0 2.107.946 3.117 2.516 3.117s2.537-1.01 2.537-3.117v-1.44c0-2.107-.968-3.096-2.537-3.096-1.57 0-2.516.989-2.516 3.096ZM81.415 17.095v-5.74h-1.87V9.053h1.87V5.7h2.946v3.354h2.816v2.3h-2.816v5.311c0 1.462.494 1.913 1.634 1.913.43 0 .967-.043 1.354-.15v2.408c-.494.129-1.333.237-2 .237-2.58 0-3.934-1.441-3.934-3.978ZM74.065 17.633V4.518h2.946v12.319c0 1.311.215 1.763 1.118 1.763.43 0 .817-.065 1.053-.172v2.386c-.451.151-1.16.259-1.763.259-2.257 0-3.354-1.054-3.354-3.44ZM67.45 17.633V4.518h2.945v12.319c0 1.311.215 1.763 1.118 1.763.43 0 .817-.065 1.054-.172v2.386c-.452.151-1.161.259-1.763.259-2.258 0-3.354-1.054-3.354-3.44ZM59.96 8.753c3.118 0 5.311 1.763 5.311 5.332v1.892h-7.59c.13 1.87 1.29 2.666 3.161 2.666 1.42 0 2.58-.108 4.171-.946v2.3c-1.419.796-2.709 1.076-4.644 1.076-3.612 0-5.676-1.914-5.676-5.44v-1.419c0-3.462 2.15-5.461 5.268-5.461Zm0 2.344c-1.44 0-2.235.967-2.278 2.859h4.6c-.02-1.978-.773-2.86-2.321-2.86ZM36.094 9.054h2.924l2.02 8.708 2.688-8.708h2.602l2.644 8.664 2-8.664h2.816l-3.31 11.911h-2.99l-2.493-8.277-2.602 8.277h-2.945L36.094 9.054Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#welltory-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.2c0-3.92 0-5.88.763-7.378A7 7 0 0 1 3.823.763C5.318 0 7.28 0 11.2 0h7.6c3.92 0 5.88 0 7.378.763a7 7 0 0 1 3.059 3.06C30 5.318 30 7.28 30 11.2v7.6c0 3.92 0 5.88-.763 7.378a7 7 0 0 1-3.06 3.059C24.682 30 22.72 30 18.8 30h-7.6c-3.92 0-5.88 0-7.378-.763a7 7 0 0 1-3.059-3.06C0 24.682 0 22.72 0 18.8v-7.6Z",
    fill: "#151A22"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#welltory-logo_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#welltory-logo_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.744 12.067c-.174-4.248-3.257-5.104-4.697-5.063-2.236 0-4.13.898-5.692 2.692a.27.27 0 0 1-.42-.027c-1.709-2.452-5.438-2.873-7.333-1.922-1.97.99-2.84 2.715-2.84 4.568 0 7.41 7.526 12.344 10.488 12.344 2.47 0 10.75-6.296 10.494-12.592Z",
    fill: "url(#welltory-logo_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.115 10.34C5.99 8.735 8.213 7.5 9.695 7.377c1.438-.12 3.573.11 5.278 2.267a.244.244 0 0 0 .35.041c.94-.81 1.206-1.621 3.754-2.432-1.481.741-2.345 1.482-4.074 3.457-1.195 1.366-2.716 2.099-4.938 2.099-1.358 0-3.805-.588-3.95-2.47Z",
    fill: "#C92E00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.855 15.524c.119.244-.004.455-.283.59-.28.136-.586.025-.704-.22-.119-.243-.004-.528.276-.663.279-.136.593.05.711.293ZM13.56 18.986c-.08-.26.073-.449.37-.54.297-.09.624.153.704.412.08.26-.12.436-.416.527-.297.091-.58-.14-.659-.4ZM8.09 16.265a.482.482 0 0 1 .303-.601c.297-.091.662.11.74.37.08.259-.16.388-.456.48-.297.09-.555-.148-.586-.249Z",
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.917,
    cy: 11.476,
    rx: 0.21,
    ry: 0.247,
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.984 16.782c0 .205-.177.37-.45.37-.272 0-.493-.165-.493-.37 0-.204.221-.271.494-.271.272 0 .449.067.449.271ZM19.325 19.475c0 .204-.177.37-.45.37-.272 0-.538-.166-.538-.37 0-.205.266-.396.538-.396.273 0 .45.191.45.396Z",
    fill: "#FFAA54"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.586-.458C6.036-.667 4.154-.225 2.557.866 4.411 1.923 6.791 3.9 8.115 6.803c.746 1.635.398 4.225 2.252 5.15 2.045 1.019 3.752-1.365 4.237-2.377.089-.616.027-2.245-.927-3.829-1.191-1.98-1.974-1.97-4.37-4.093C8.115.598 8.122-.386 7.586-.458Z",
    fill: "url(#welltory-logo_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.819 11.203c0 .204-.29.37-.494.37a.37.37 0 1 1 0-.74c.204 0 .494.165.494.37Z",
    fill: "#CF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.276 7.81c.229-.009.428.329.438.573.01.244-.167.449-.395.458-.229.01-.422-.18-.432-.425-.01-.243.161-.596.39-.605Z",
    fill: "#FFA600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.812 3.868c.229-.01.432.433.445.751.013.319-.161.585-.39.594-.228.01-.424-.241-.437-.56-.012-.318.154-.776.382-.785ZM16.461 6.494c.07.094-.031.285-.142.367-.111.08-.257.07-.326-.024-.069-.095-.035-.237.076-.318.11-.081.323-.12.392-.025Z",
    fill: "#CF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.701 7.768c.08.108-.012.312-.123.393a.247.247 0 0 1-.345-.05.247.247 0 0 1 .057-.345c.11-.081.332-.107.412.002Z",
    fill: "#FF6B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.593 6.002c-.109-.08-.081-.302 0-.412a.247.247 0 0 1 .345-.055c.108.08.13.235.048.346-.081.11-.285.201-.393.12Z",
    fill: "#FEA900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.794 2.067c-.135-.01-.134-.11-.124-.247.01-.137.01-.291.145-.281.135.01.235.13.224.267-.01.137-.11.271-.245.26Z",
    fill: "#CC5616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.114 4.66c-.108-.081-.035-.2 0-.248.11-.147.307-.417.37-.37.09.066.025.317-.084.464-.06.08-.177.234-.286.153Z",
    fill: "#E39932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98 2.684c-.297-.197-.494-.37-.741-.37-.74 0-.494 1.11-.247 1.481.247.37.988.617 1.235.494.246-.123.246-.37.246-.617s-.123-.741-.493-.988Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.053 6.265c-.617-.463-1.316-1.523-1.728-2.099-.213-.298-.367 0-.37.247 0 .247-.027 2.145.494 2.84.74.987 1.11.987 1.604.493.315-.315.494-1.111 0-1.481Z",
    fill: "#FF5B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.338 8.486c0-.247-.494-.74-.865-1.234-.296-.395-.7-.412-.864-.37-.082 0-.271.073-.37.37-.124.37.123.74.37.864.11.055.617.123.988.494.315.314.74.123.74-.124ZM14.107 10.864c-.392.367-1.513 1.038-2.13 1.19a.071.071 0 0 1-.082-.044c-.239-.598-.467-1.196-.348-1.795.214-1.07.7-1.028.988-.864.561.321 1.217.37 1.59 1.438a.071.071 0 0 1-.018.075Z",
    fill: "#FF6B30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "welltory-logo_svg__b",
    x: -0.675,
    y: -2.006,
    width: 30.375,
    height: 32.591,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.975
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.975
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.327091 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3340_1027"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3340_1027",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "welltory-logo_svg__c",
    x: 3.775,
    y: 6.015,
    width: 21.974,
    height: 18.644,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.988,
    dy: -0.988
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.988
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_3340_1027"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "welltory-logo_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(82.933 1.455 11.595) scale(18.0462 17.2022)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#FF4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#B80747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "welltory-logo_svg__e",
    x1: 8.586,
    y1: 8.438,
    x2: 4.497,
    y2: -0.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "welltory-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgWelltoryLogo;